export default "__VITE_ASSET__BfHwJBLd__"